module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.question.statement))]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "value": _vm.getAnswerAsDateObject(),
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "required": _vm.question.required,
      "disabled": _vm.disabledAttribute,
      "disabled-dates": _vm.disabledDates
    },
    on: {
      "selected": _vm.onDateSelected
    }
  }), _vm._v(" "), (_vm.m_error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.m_error))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7647cdf8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/DateQuestion.vue
// module id = 692
// module chunks = 1